import React from 'react';
import { useController, useFormContext } from 'react-hook-form';

import styles from './QuestionnaireResultWithScoringDetailScorePicker.module.scss';

interface Props {
	name: string;
	maxScore: number;
}

const QuestionnaireResultWithScoringDetailScorePicker: React.FC<Props> = ({
	name,
	maxScore,
}) => {
	const { control } = useFormContext();

	const { field } = useController({
		control,
		name,
		defaultValue: '',
	});

	const values = Array.from({ length: maxScore + 1 }, (_, index) => index);

	return (
		<div className={styles.wrapper}>
			{values.map(value => {
				const isActive =
					field.value !== '' &&
					field.value !== null &&
					field.value !== undefined &&
					String(field.value) === String(value);

				return (
					<button
						key={value}
						type='button'
						className={`${styles.item} ${isActive ? styles.active : ''}`}
						onClick={() => field.onChange(String(value))}>
						{value}
					</button>
				);
			})}
		</div>
	);
};

export default QuestionnaireResultWithScoringDetailScorePicker;
